// extracted by mini-css-extract-plugin
module.exports = {"folderItem":"folder-view_folderItem__1ZzqF","folderIcon":"folder-view_folderIcon__2pIi0","dropHover":"folder-view_dropHover__RaCOV"};